import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { PrimaryButton } from "./Primitives";
import { toast } from "sonner";

export const AuthForm = ({ onDone, intro }) => {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("register");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "register") await register(form.email, form.password, form.name);
      else await login(form.email, form.password);
      toast.success("Welcome to the cottage.");
      onDone && onDone();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  const cls = "w-full bg-brand-warm-white border border-brand-linen px-5 py-4 font-body text-brand-charcoal focus:outline-none focus:border-brand-gold transition-colors";
  return (
    <div className="w-full max-w-md mx-auto" data-testid="auth-form">
      {intro}
      <div className="flex gap-2 mb-6">
        {["register", "login"].map((m) => (
          <button key={m} onClick={() => setMode(m)} data-testid={`auth-tab-${m}`}
            className={`flex-1 font-sans text-[0.72rem] uppercase tracking-[0.14em] py-3 border transition-colors ${mode === m ? "bg-brand-olive text-brand-cream border-brand-olive" : "border-brand-linen text-brand-body"}`}>
            {m === "register" ? "Create account" : "Sign in"}
          </button>
        ))}
      </div>
      <form onSubmit={submit} className="space-y-4">
        {mode === "register" && <input placeholder="Your name" value={form.name} onChange={set("name")} data-testid="auth-name" className={cls} />}
        <input type="email" required placeholder="Email" value={form.email} onChange={set("email")} data-testid="auth-email" className={cls} />
        <input type="password" required placeholder="Password" value={form.password} onChange={set("password")} data-testid="auth-password" className={cls} />
        <PrimaryButton type="submit" testid="auth-submit" disabled={loading}>
          {loading ? "…" : mode === "register" ? "Create account" : "Sign in"}
        </PrimaryButton>
      </form>
    </div>
  );
};
